import React, { useState } from "react";

const dietaryOptions = [
  "Alcohol-Free", "Allergy", "Allium", "Celery", "Crustacean",
  "Dairy-Free", "Diabetic", "Eggs", "Fish", "Garlic",
  "Gluten-Free", "Halal", "Hazelnut", "Kosher", "Lactose Intolerant",
  "Lupin", "Milk", "Mushrooms", "Mustard", "Nuts", "Paleo",
  "Peanuts", "Pescatarian", "Poultry", "Pregnant", "Red Meat",
  "Salt", "Seafood", "Sesame", "Shellfish", "Shrimp", "Soy",
  "Sulfites", "Tomatoes", "Tree Nuts", "Vegan", "Vegetarian",
  "Walnuts", "Wheat"
];

export default function DietaryPopup({ onClose, selected = [], onSave }) {
  const [selectedOptions, setSelectedOptions] = useState(new Set(selected));
  const [activeTab, setActiveTab] = useState("yours");

  const toggleOption = (option) => {
    const updated = new Set(selectedOptions);
    if (updated.has(option)) {
      updated.delete(option);
    } else {
      updated.add(option);
    }
    setSelectedOptions(updated);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
      <div className="bg-white max-w-3xl w-full rounded-xl overflow-hidden shadow-xl">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-4 py-3 text-sm font-semibold">
          <button onClick={onClose}>CANCEL</button>
          <div className="flex flex-1 justify-center">
            <button
              onClick={() => setActiveTab("yours")}
              className={`w-1/2 text-center border-r py-2 ${
                activeTab === "yours" ? "font-bold" : "text-gray-500"
              }`}
            >
              YOURS
            </button>
            <button
              onClick={() => setActiveTab("guests")}
              className={`w-1/2 text-center py-2 ${
                activeTab === "guests" ? "font-bold" : "text-gray-500"
              }`}
            >
              YOUR GUESTS
            </button>
          </div>
          <button onClick={() => onSave([...selectedOptions])}>SAVE</button>
        </div>

        {/* Options */}
        <div className="p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {dietaryOptions.map((option) => (
            <button
              key={option}
              onClick={() => toggleOption(option)}
              className={`flex items-center justify-between border rounded-full px-3 py-1 text-sm shadow-sm transition-all duration-150 ${
                selectedOptions.has(option) ? "bg-black text-white" : "bg-white"
              }`}
            >
              {option}
              <div
                className={`w-4 h-4 rounded-full border ml-2 ${
                  selectedOptions.has(option) ? "bg-white" : ""
                }`}
              ></div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
